export default "__VITE_ASSET__bedfbe0c__"